import React from 'react';
import { CheckCircle, XCircle, Clock } from 'lucide-react';

export default function StatusHeader({ isSuccess, isPending, result }) {
  return (
    <div className="text-center mb-6">
      {isSuccess && (
        <>
          <CheckCircle className="w-20 h-20 mx-auto mb-4 text-green-500" />
          <h1 className="text-3xl font-bold text-green-600 mb-2">Payment Successful!</h1>
          <p className="text-gray-600">Your booking has been confirmed</p>
        </>
      )}

      {isPending && (
        <>
          <Clock className="w-20 h-20 mx-auto mb-4 text-yellow-500" />
          <h1 className="text-3xl font-bold text-yellow-600 mb-2">Payment Processing</h1>
          <p className="text-gray-600">Your payment is being verified. Please check back shortly.</p>
        </>
      )}

      {!isSuccess && !isPending && (
        <>
          <XCircle className="w-20 h-20 mx-auto mb-4 text-red-500" />
          <h1 className="text-3xl font-bold text-red-600 mb-2">Payment Failed</h1>
          <p className="text-gray-600">
            {result.status_details?.message || 'Your payment could not be processed'}
          </p>
        </>
      )}
    </div>
  );
}
